import React from 'react'
import style from './style.module.scss'
import { useTranslate } from '@tolgee/react';

export const PropertyAdditionalMaterialsTitle = () => {
  const { t: tOpportunityDetailPageDisclaimer } = useTranslate('opportunity_detail_page.additional_material');
  
  return (
    <div className="d-flex align-items-center text-primary">
      <div className={style["additional-materials__text"]}>
        {tOpportunityDetailPageDisclaimer('opportunity_detail_page.additional_material')}
      </div>
    </div>
  )
}